export const MESSAGES_CHAT_URL = `${process.env.PUBLIC_URL || ""}/messages-chat.json`;

export const STARTER_QUESTIONS = [
  "Generate a follow-up email for a potential lead.",
  "Draft a quick update to share with the exec team.",
  "Find inconsistencies in our latest performance data.",
  "Review this document and extract action items.",
];

export const CHAT_INPUT_ADD_MENU_ITEMS = [
  { icon: "attach_file", text: "Upload File", value: "upload", showTag: true, tagColor: "success" },
  { icon: "hardDrive2", text: "Add from AIMS Drive", value: "drive", showTag: true, tagColor: "success" },
  /*{
    title: "Modes",
    defaultOpen: true,
    hideChevron: true,
    items: [
      { text: "Web Search", value: "web", showTag: true, tagColor: "lightBlue" },
      {
        text: "Deep Search",
        value: "deep",
        showTag: true,
        tagColor: "success",
        menu: [
          { value: "sandbox", label: "Sandbox" },
          { value: "truth", label: "Truth" },
          { value: "web_search", label: "Web search" },
        ],
        menuLabel: "Source",
        menuType: "grey",
      },
      {
        text: "Tools Mode",
        value: "tools",
        showTag: true,
        tagColor: "success",
        menu: [
          { value: "inventory", label: "Inventory search" },
          { value: "customer", label: "Customer search" },
        ],
        menuLabel: "Tool",
        menuType: "grey",
      },
      {
        text: "Reasoning Mode",
        value: "reasoning",
        showTag: true,
        tagColor: "success",
        menu: [
          { value: "high", label: "High" },
          { value: "medium", label: "Medium" },
          { value: "low", label: "Low" },
        ],
        defaultMenuValue: "medium",
        menuType: "purple",
      },
      {
        text: "Custom Mode",
        value: "custom",
        items: [
          { text: "Customer Search", value: "customer", showTag: true, tagColor: "lightBlue" },
          { text: "Inventory Mode", value: "inventory", showTag: true, tagColor: "success" },
          { icon: "settings", text: "Custom", value: "custom_settings", showTag: true, tagColor: "success" },
        ],
      },
      {
        text: "More",
        value: "more",
        items: [
          { text: "Send Email", value: "email", showTag: true, tagColor: "success" },
          { text: "Create Note", value: "note", showTag: true, tagColor: "success" },
        ],
      },
    ],
  },*/
];

export const DOCUMENT_SEARCH_PROPS = {
  searchPlaceholder: "Search documents...",
  maxHeight: "500px",
  height: "500px",
};

export const MOCK_DOCUMENTS = [
  {
    id: "1",
    title: "Sample Document Title: A Brief Overv...",
    agentName: "{Agent name}",
    driveName: "{Drive name}",
    description:
      "This section provides a concise description, ensuring clarity and brevity. If the text excee...",
  },
  {
    id: "2",
    title: "Another Document Example",
    agentName: "Agent Alpha",
    driveName: "My Drive",
    description:
      "A second document with different metadata for demonstration purposes.",
  },
  {
    id: "3",
    title: "Third Sample Document",
    agentName: "Agent Beta",
    driveName: "Shared Drive",
    description:
      "Additional content to show the list scroll and card layout behavior.",
  },
];

